import React, { useState } from 'lib/react';
import {
  EVPaper, makeStyles,
} from 'lib/components';
import PropTypes from 'prop-types';
import Popper from 'commonComponents/popper';
import FilesDropdownContent from './filesDropdownContent.component';

export const useStyles = makeStyles((theme) => ({
  popper: {
    zIndex: 10001,
  },
  reportFilesDropdown: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    gap: '16px',
    '& span,p,label': {
      fontSize: '14px',
      lineHeight: '19px',
      textTransform: 'none',
    },
    '& .heading': {
      fontWeight: 600,
      fontSize: '18px',
      lineHeight: '27px',
    },
  },
  filesDropdownBtn: {
    minWidth: 'unset',
    padding: '0px 8px 0px 8px',
    borderLeft: `1px solid ${theme.evPalette.salt[100]}`,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  detailsBtnLabel: {
    padding: 0,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19px',
    textTransform: 'none',
  },
}));

function ReportFilesDropdown({
  reportId, handleClickAway, open, anchorEl, primaryProductID, showFilesEsxUpgrade, popperPlacement,
}) {
  const classes = useStyles();
  const [showEmailOptions, setShowEmailOptions] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [emailFiles, setEmailFiles] = useState({});

  const handleShowEmailOptionsChange = (files) => {
    setEmailFiles(files);
    setShowEmailOptions(true);
  };

  return (
    <Popper
      popperId={`filesDropdown-${reportId}`}
      className={classes.popper}
      placement={popperPlacement}
      anchorEl={anchorEl}
      open={open}
      modifiers={{ offset: { offset: '0,5px' } }}
      onClickAway={handleClickAway}
    >
      <EVPaper className={classes.reportFilesDropdown}>
        <FilesDropdownContent
          reportId={reportId}
          showEmailOptions={showEmailOptions}
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
          emailFiles={emailFiles}
          setShowEmailOptions={setShowEmailOptions}
          handleShowEmailOptionsChange={handleShowEmailOptionsChange}
          handleClickAway={handleClickAway}
          primaryProductID={primaryProductID}
          showFilesEsxUpgrade={showFilesEsxUpgrade}
        />
      </EVPaper>
    </Popper>
  );
}

ReportFilesDropdown.defaultProps = {
  anchorEl: null,
  showFilesEsxUpgrade: false,
  popperPlacement: 'left-end',
};

ReportFilesDropdown.propTypes = {

  reportId: PropTypes.number.isRequired,
  primaryProductID: PropTypes.number.isRequired,
  handleClickAway: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  showFilesEsxUpgrade: PropTypes.bool,
  anchorEl: PropTypes.oneOfType([PropTypes.element, PropTypes.object, PropTypes.func]),
  popperPlacement: PropTypes.string,
};

export default ReportFilesDropdown;
